"use client";

import { useRef } from "react";
import { ArrowUpRight, Download, ShieldCheck } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { Button } from "@/components/ui/button";
gsap.registerPlugin(useGSAP);
export default function Eurocontrol() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.to(".sec-shield", {
        opacity: 0.5,
        duration: 1.2,
        ease: "power2.out"
      });
      gsap.set(".sec-reveal", {
        y: 24,
        filter: "blur(8px)"
      });
      gsap.to(".sec-reveal", {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 0.8,
        stagger: 0.12,
        ease: "power3.out",
        delay: 0.2
      });
      gsap.to(".sec-shield", {
        rotate: 2,
        duration: 15,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut"
      });
      gsap.to(".sec-shield", {
        scale: 1.02,
        duration: 12,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut"
      });
      gsap.to(".sec-glow", {
        opacity: 0.22,
        duration: 4,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut"
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set(".sec-shield", {
        opacity: 0.5
      });
      gsap.set(".sec-reveal", {
        opacity: 1,
        y: 0,
        filter: "blur(0px)"
      });
      gsap.set(".sec-glow", {
        opacity: 0.2
      });
    });
  }, {
    scope: container
  });
  return;
}